import { IsDevEnv, Settings, TestPanel } from '@/app'
import { APIClient } from '@/services'
import { AnyFunction } from '@codeleap/common'
import { useLinkedIn } from 'react-linkedin-login-oauth2'
import { getLinkedInAccessToken } from '.'

export function getRedirectUri() {
  let baseUrl = TestPanel.getWebsiteUrl().replace(/\/$/, '')
  if (IsDevEnv) baseUrl = 'http://localhost:8000'
  return `${baseUrl}/auth/linkedIn/`
}

const LinkedInAuth = Settings.ApiCredentials.LinkedIn

export function useLinkedInAuth(handler: AnyFunction) {
  const onSuccess = async (code: string) => {
    try {
      const tokenData = await getLinkedInAccessToken(code)

      if (!tokenData?.access_token) return

      const socialResult = await APIClient.Session.socialLogin({
        provider: 'linkedIn',
        params: tokenData.access_token,
      })

      handler?.(socialResult)
    } catch (error) {
      console.error('LinkedIn auth error:', error)
    }
  }

  const redirectUri = getRedirectUri()

  const { linkedInLogin } = useLinkedIn({
    clientId: LinkedInAuth.ClientID,
    redirectUri,
    scope: 'r_liteprofile r_emailaddress',
    onSuccess,
    onError: error => {
      console.error('LinkedIn login error:', error)
    },
  })

  return linkedInLogin
}
